import { render } from "./GalleryAuthors.vue?vue&type=template&id=7096fa90&scoped=true"
import script from "./GalleryAuthors.vue?vue&type=script&lang=js"
export * from "./GalleryAuthors.vue?vue&type=script&lang=js"

import "./GalleryAuthors.vue?vue&type=style&index=0&id=7096fa90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7096fa90"]])

export default __exports__